(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-background"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.background-video-section');
  const videoSource = section.dataset.videoSource;

  if (videoSource === 'youtube') {
    const youtubeContainer = section.querySelector('.youtube');
    if (youtubeContainer) {
      const videoId = youtubeContainer.dataset.videoId;
      loadYouTubeVideo(youtubeContainer, videoId);
    }
  } else if (videoSource === 'vimeo') {
    const vimeoContainer = section.querySelector('.vimeo');
    if (vimeoContainer) {
      const videoId = vimeoContainer.dataset.videoId;
      loadVimeoVideo(vimeoContainer, videoId);
    }
  }
});

function loadYouTubeVideo(container, videoId) {
  const player = new YT.Player(container, {
    videoId: videoId,
    playerVars: {
      autoplay: 1,
      loop: 1,
      controls: 0,
      showinfo: 0,
      rel: 0,
      enablejsapi: 1,
      modestbranding: 1,
      mute: 1,
      playsinline: 1,
      playlist: videoId
    },
    events: {
      onReady: function(event) {
        event.target.mute();
        event.target.playVideo();
      }
    }
  });
}

function loadVimeoVideo(container, videoId) {
  const options = {
    id: videoId,
    background: true,
    autoplay: true,
    loop: true,
    muted: true,
    controls: false
  };
  
  const player = new Vimeo.Player(container, options);
  player.play();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-display"] && !window.DesignMode) return;
  try {
    
// Add this script tag to your theme.liquid file if not already present
// <script src="https://www.youtube.com/iframe_api"></script>
// <script src="https://player.vimeo.com/api/player.js"></script>

document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.background-video-section');
  const videoSource = section.dataset.videoSource;

  if (videoSource === 'youtube') {
    const youtubeContainer = section.querySelector('.youtube');
    if (youtubeContainer) {
      const videoId = youtubeContainer.dataset.videoId;
      // Wait for YouTube API to be ready
      if (window.YT) {
        loadYouTubeVideo(youtubeContainer, videoId);
      } else {
        window.onYouTubeIframeAPIReady = function() {
          loadYouTubeVideo(youtubeContainer, videoId);
        };
      }
    }
  } else if (videoSource === 'vimeo') {
    const vimeoContainer = section.querySelector('.vimeo');
    if (vimeoContainer) {
      const videoId = vimeoContainer.dataset.videoId;
      loadVimeoVideo(vimeoContainer, videoId);
    }
  }

  // Handle self-hosted video
  const selfHostedVideo = section.querySelector('video');
  if (selfHostedVideo) {
    selfHostedVideo.play().catch(function(error) {
      console.log("Video autoplay failed:", error);
    });
  }
});

function loadYouTubeVideo(container, videoId) {
  new YT.Player(container, {
    videoId: videoId,
    width: '100%',
    height: '100%',
    playerVars: {
      autoplay: 1,
      loop: 1,
      controls: 0,
      showinfo: 0,
      rel: 0,
      enablejsapi: 1,
      modestbranding: 1,
      mute: 1,
      playsinline: 1,
      playlist: videoId
    },
    events: {
      onReady: function(event) {
        event.target.mute();
        event.target.playVideo();
      },
      onStateChange: function(event) {
        if (event.data === YT.PlayerState.ENDED) {
          event.target.playVideo();
        }
      }
    }
  });
}

function loadVimeoVideo(container, videoId) {
  const options = {
    id: videoId,
    background: true,
    autoplay: true,
    loop: true,
    muted: true,
    controls: false,
    responsive: true,
    width: '100%',
    height: '100%'
  };
  
  const player = new Vimeo.Player(container, options);
  
  player.ready().then(function() {
    player.play();
    player.setVolume(0);
  }).catch(function(error) {
    console.log("Vimeo player error:", error);
  });
}

  } catch(e) { console.error(e); }
})();
})();
